import React from "react";
import { BsWhatsapp } from "react-icons/bs";

const WhatsAppButton = ({ Href = "5211234567890", Text = "Hola, quiero más información" }) => {
  return (
    <a
      href={`https://api.whatsapp.com/send/?phone=${Href}&text=${encodeURIComponent(Text)}&type=phone_number&app_absent=0`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-16 h-16 bg-green-500 text-white rounded-full shadow-lg hover:scale-110 transition-transform"
    >
      <BsWhatsapp className="text-4xl" />
    </a>
  );
};

export default WhatsAppButton;
